export default __webpack_public_path__ + "42d5f70628e84c220332fb4368f950d1.jpg";